import { useMemo } from 'react';

import useDebounce, { debounceTimes } from 'src/hooks/useDebounce';
import type { FilterContextValue } from 'src/components/app/context/FilterContext';
import { useFilterContext } from 'src/components/app/context/FilterContext';

export interface DashboardFilterContextValue extends FilterContextValue {
  flatFilters: Record<string, string[]>;
  flatFiltersDebounced: Record<string, string[]>;
}

export const useDashboardFilters = (): DashboardFilterContextValue => {
  const { filterGroups, ...rest } = useFilterContext();

  const flatFilters = useMemo(() => {
    const flatFilters: Record<string, string[]> = {};

    Object.entries(filterGroups).forEach(([name, filterGroups]) => {
      if (!flatFilters[name]) {
        flatFilters[name] = [];
      }

      filterGroups.forEach((filterValue) => {
        flatFilters[name] = [
          ...flatFilters[name],
          filterValue.filterExpr[name],
        ];
      });
    });

    return flatFilters;
  }, [filterGroups]);

  const flatFiltersDebounced = useDebounce(
    flatFilters,
    debounceTimes.FLAT_FILTERS,
  );

  return { filterGroups, flatFilters, flatFiltersDebounced, ...rest };
};

export default useDashboardFilters;
